import { IFRAME_CONFIG } from '../config';

const isMd = pageInfo => pageInfo.documentWidth >= IFRAME_CONFIG.mdBreakpoint;

export const getRestaurantMenuModalStyle = pageInfo => {
  const customOffset = isMd(pageInfo) ? 30 : 10
  const calculatedTop = pageInfo.scrollTop - pageInfo.offsetTop + IFRAME_CONFIG.fixedHeaderHeight - customOffset;
  return {
    top: Math.max(0, calculatedTop),
  }
}

const modalHeaderHeight = 62;
const modalFooterHeight = 60;

export const getRestaurantMenuModalBodyStyle = pageInfo => {
  const heightToSubstract = isMd(pageInfo)
    ? IFRAME_CONFIG.menuModalSubstract
    : IFRAME_CONFIG.menuModalSubstractMd;
  return {
    maxHeight: Math.max(pageInfo.windowHeight - IFRAME_CONFIG.fixedHeaderHeight - heightToSubstract - modalHeaderHeight, 250),
    overflowY: 'scroll'
  };
}

export const getRestaurantMenuNavStyle = pageInfo => {
  const customOffset = isMd(pageInfo) ? IFRAME_CONFIG.menuNavOffsetMd : IFRAME_CONFIG.menuNavOffset;
  const top = pageInfo.scrollTop - customOffset - pageInfo.offsetTop + IFRAME_CONFIG.fixedHeaderHeight;
  return {
    top: Math.max(top, 0)
  };
};

export const getDishModalStyle = pageInfo => {
  const calculatedTop = pageInfo.scrollTop - pageInfo.offsetTop + IFRAME_CONFIG.fixedHeaderHeight;
  return { top: Math.max(calculatedTop, 100, IFRAME_CONFIG.fixedHeaderHeight) };
};

export const getDishModalBodyStyle = pageInfo => {
  const heightToSubstract = isMd(pageInfo)
    ? 50
    : 0;
  return {
    maxHeight: Math.max(pageInfo.windowHeight - IFRAME_CONFIG.fixedHeaderHeight - modalHeaderHeight - heightToSubstract - modalFooterHeight, 250),
    overflowY: 'scroll'
  };
};

export const getRestaurantMenuFabStyle = pageInfo => {
  const customOffset = pageInfo.documentWidth >= isMd(pageInfo)
    ? IFRAME_CONFIG.fabBtnOffsetMd
    : IFRAME_CONFIG.fabBtnOffset;
  const calculatedTop = pageInfo.scrollTop + pageInfo.documentHeight - pageInfo.offsetTop - customOffset;
  return {
    top: Math.min(pageInfo.iframeHeight, calculatedTop),
    bottom: 'auto',
    transform: 'translateY(calc(-100% - 15px))',
    right: 15,
  }
};

const IFRAME_STYLE_HELPER = {
  getRestaurantMenuModalStyle,
  getRestaurantMenuModalBodyStyle,
  getRestaurantMenuNavStyle,
  getDishModalStyle,
  getDishModalBodyStyle,
  getRestaurantMenuFabStyle
};

export default IFRAME_STYLE_HELPER;
